// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IsolationUnit } from './IsolationUnit';
import {
  IsolationUnitFromJSON,
  IsolationUnitFromJSONTyped,
  IsolationUnitToJSON,
  IsolationUnitToJSONTyped,
} from './IsolationUnit';

/**
 *
 * @export
 * @interface IsolationUnitListResponse
 */
export interface IsolationUnitListResponse {
  /**
   *
   * @type {Array<IsolationUnit>}
   * @memberof IsolationUnitListResponse
   */
  items?: Array<IsolationUnit>;
}

/**
 * Check if a given object implements the IsolationUnitListResponse interface.
 */
export function instanceOfIsolationUnitListResponse(
  value: object,
): value is IsolationUnitListResponse {
  return true;
}

export function IsolationUnitListResponseFromJSON(
  json: any,
): IsolationUnitListResponse {
  return IsolationUnitListResponseFromJSONTyped(json, false);
}

export function IsolationUnitListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IsolationUnitListResponse {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(IsolationUnitFromJSON),
  };
}

export function IsolationUnitListResponseToJSON(
  json: any,
): IsolationUnitListResponse {
  return IsolationUnitListResponseToJSONTyped(json, false);
}

export function IsolationUnitListResponseToJSONTyped(
  value?: IsolationUnitListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(IsolationUnitToJSON),
  };
}
